/**
 * Highlight Polygon Index
 * 
 * @Author: Focci
 * @Date: 2024-09-14 13:58:13
 * @Last Modified by: Focci
 * @Last Modified time: 2024-09-14 13:58:13
 */

// import PropTypes from 'prop-types'
import { isFunction } from 'lodash-es'
import { useCallback, useEffect, useMemo, useState } from 'react'
import SuburbPolygon from './SuburbPolygon'
import { getFetcher } from './lib'

export default function HighlightSuburb({
  data,
  onHighlightSuburbClick,
  autoMoveToCenter = true,
}) {
  const [currentIds, setCurrentIds] = useState([])
  const [feature, setFetcher] = useState()
  const [lock, setLock] = useState(false)

  const markerProps = useMemo(() => ({
    onOpen: () => setLock(true),
    onClose: () => setLock(false),
  }), [])
  
  const handleClick = useCallback((newParam, type) => {
    isFunction(onHighlightSuburbClick) && onHighlightSuburbClick({ newParam, type })
    type === 'item' && setLock(false)
  }, [onHighlightSuburbClick])

  const handleMousemove = useCallback((e) => {
    const v = currentIds[0] === e.features?.[0]?.properties?.id ? null : getFetcher(e)
    setFetcher(v)
  }, [currentIds])
  
  useEffect(() => {
    setCurrentIds(data?.suburbId ? [data?.suburbId] : [])
  }, [data?.suburbId])

  return (
    <SuburbPolygon
      lock={lock}
      currentIds={currentIds}
      feature={feature}
      autoMoveToCenter={autoMoveToCenter}
      markerProps={markerProps}
      onClick={handleClick}
      onMousemove={handleMousemove}
      onMouseleave={() => setFetcher()}
      onPolygonChange={(v) => setCurrentIds(v)}
    />
  )
}
